import styled from 'styled-components'
import { Modal } from 'reactstrap'

export const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 8px;
    border: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  }

  .modal-header {
    border-bottom: 1px solid #e0e0e0;
    padding: 20px 24px;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;
  }

  .modal-body {
    padding: 24px;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
  }

  .modal-footer {
    border-top: 1px solid #e0e0e0;
    padding: 16px 24px;
    background: #f8f9fa;
    border-radius: 0 0 8px 8px;
  }
`

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #333;

  svg {
    color: #667eea;
  }
`

export const ModalContent = styled.div`
  position: relative;
`

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 1050;
  border-radius: 8px;

  svg {
    color: #667eea;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin: 0;
  }
`

export const WarningBanner = styled.div`
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #856404;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const InfoBox = styled.div`
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border: 1px solid #2196f3;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #0d47a1;
  line-height: 1.5;

  strong {
    font-weight: 600;
    color: #1565c0;
  }
`

// MODE LECTURE
export const ReadOnlySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const AddressField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FieldLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const FieldValue = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #333;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  min-height: 44px;
  display: flex;
  align-items: center;
`

export const TwoColumnRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`

// MODE ÉDITION
export const EditSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const FormGroup = styled.div<{ hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #333;

  &::after {
    content: '';
  }

  /* Ajouter * pour les champs requis */
  &:has(+ input:required)::after,
  &:contains('*')::after {
    content: '';
  }
`

export const FormInput = styled.input<{ hasError?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: #333;
  padding: 10px 12px;
  border: 1px solid ${props => props.hasError ? '#f5576c' : '#e0e0e0'};
  border-radius: 4px;
  transition: all 0.2s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#f5576c' : '#667eea'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(245, 87, 108, 0.1)' : 'rgba(102, 126, 234, 0.1)'};
  }

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.6;
  }

  &::placeholder {
    color: #999;
  }
`

export const FormHint = styled.div`
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;

  &::before {
    content: 'ℹ️';
  }
`

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: #f5576c;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;

  &::before {
    content: '❌';
  }
`

// BOUTONS
export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;

  @media (max-width: 576px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`

const BaseButton = styled.button`
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 120px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`

export const PrimaryButton = styled(BaseButton)`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #5568d3 0%, #63408a 100%);
  }
`

export const SecondaryButton = styled(BaseButton)`
  background: #6c757d;
  color: white;

  &:hover:not(:disabled) {
    background: #5a6268;
  }
`
